import React from "react"
import Loading from "./loading/Loading"
import styles from "./ResponseLoader.module.css"
import ReactDOM from "react-dom";

const ResponseLoader = ({grayScale=false, fullScreen=false, text=null, simple=false, none=false, rootLevel=false}) => {
    if(none)
    {
        return (
            <div className={fullScreen ? styles.overlayFull : styles.overlay} style={grayScale?{background: "rgba(0, 0, 0, 0.2)"}:null}>
            </div>
        )
    }
    if(simple)
    {
        return ( 
            <div>
                <Loading />
                {text && <p className={styles.text}>{text}</p>}
            </div>
        )
    }
    return (
        <div className={fullScreen ? styles.overlayFull : (rootLevel ? styles.overlayRoot : styles.overlay)} style={grayScale?{background: "rgba(0, 0, 0, 0.2)"}:null}>
            <Loading />
            {text && <p className={styles.text}>{text}</p>}
        </div>
    )
}

let loaderRoot = null;

export function showLoader(grayScale=false,fullScreen=false,text=null,none=false) 
{
    if (!loaderRoot) 
    {
        loaderRoot = document.createElement("div");
        document.body.appendChild(loaderRoot);
    }

    ReactDOM.render(<ResponseLoader grayScale={grayScale} fullScreen={fullScreen} text={text} none={none} />,loaderRoot);
}

export function hideLoader() 
{
    if (loaderRoot) 
    {
        ReactDOM.unmountComponentAtNode(loaderRoot);
        document.body.removeChild(loaderRoot);
        loaderRoot = null;
    }
}

export default ResponseLoader